import React from 'react';
import Tooltip from '@amzn/meridian/tooltip';
import { WARNING_COLOR } from '@constants/values';
import Icon from '@amzn/meridian/icon';
import warning from '@amzn/meridian-tokens/base/icon/alert-warning-large';
import { TemperatureRating } from '@graphql/generated/graphql';
import Row from '@amzn/meridian/row';

const TemperatureRatingCellRenderer = (prams: { value: TemperatureRating | null | undefined }) => {
  const { value } = prams;

  if (value === null || value === undefined) {
    return (
      <Tooltip position="end" title="TempZone information is not available" id="myTooltip">
        <Row>
          <Icon className={WARNING_COLOR} tokens={warning} />
          N/A
        </Row>
      </Tooltip>
    );
  }
  if (value !== TemperatureRating.Ambient) {
    return (
      <Tooltip position="end" title={`This product is ${value}`} id="myTooltip">
        <Row>
          <Icon className={WARNING_COLOR} tokens={warning} /> {value}
        </Row>
      </Tooltip>
    );
  }
  return value;
};

export default TemperatureRatingCellRenderer;
